function selectTab(tabElement) {
  tabElement.classList.add("active");
  tabElement.ariaSelected = "true";
}

function unselectTab(tabElement) {
  tabElement.classList.remove("active");
  tabElement.ariaSelected = "false";
}

function showPane(paneElement) {
  paneElement.classList.add("active");
}

function hidePane(paneElement) {
  paneElement.classList.remove("active");
}

function initTabbedCategoriesSections() {
  const tabbedCategoriesSections = Array.from(
    document.getElementsByClassName("tabbed-categories-wrapper")
  );

  tabbedCategoriesSections.forEach((section) => {
    const forDogsTab = section.querySelector("#for-dogs-tab");
    const forDogsPane = section.querySelector("#for-dogs-pane");

    const forCatsTab = section.querySelector("#for-cats-tab");
    const forCatsPane = section.querySelector("#for-cats-pane");

    if (!forDogsTab || !forDogsPane || !forCatsTab || !forCatsPane) {
      return;
    }

    forDogsTab.addEventListener("click", () => {
      // Show dog stuff
      selectTab(forDogsTab);
      showPane(forDogsPane);

      // Hide cat stuff
      unselectTab(forCatsTab);
      hidePane(forCatsPane);
    });

    forCatsTab.addEventListener("click", () => {
      // Show cat stuff
      selectTab(forCatsTab);
      showPane(forCatsPane);

      // Hide dog stuff
      unselectTab(forDogsTab);
      hidePane(forDogsPane);
    });
  });
}

initTabbedCategoriesSections();
